export default __webpack_public_path__ + "static/media/pieinthesky.e8f7056d.jpg";